/* eslint-disable no-param-reassign */
export const selectAccommodation = (accommodationGroups, id, bedroomType) => {
  accommodationGroups.forEach((group) => {
    group.accommodations.forEach((accommodation) => {
      accommodation.priceRanges.forEach((priceRange) => {
        if (priceRange.bedroom === bedroomType) {
          priceRange.selected = true;
          if (accommodation.id === id) {
            accommodation.selected = true;
            group.selected = true;
          }
        }
      });
    });
  });

  return accommodationGroups;
};

export const selectAccommodationById = (accommodationGroups, id) => {
  accommodationGroups.forEach((group) => {
    group.selected = false;
    group.accommodations.forEach((a) => {
      if (a.id === parseInt(id, 10)) group.selected = true;
    });
  });

  return accommodationGroups;
};

export const selectCheapestAccommodation = (accommodationGroups) => {
  setCheapestPriceRanges(accommodationGroups);
  setCheapestAccommodations(accommodationGroups);
  setCheapestAccommodationGroup(accommodationGroups);
};

const setCheapestPriceRanges = (accommodationGroups) => {
  accommodationGroups.forEach((accommodationGroup) => {
    setCheapestPriceRange(accommodationGroup);
  });
};

const setCheapestAccommodations = (accommodationGroups) => {
  accommodationGroups.forEach((accommodationGroup) => {
    const cheapestPriceRange =
      findCheapestPriceRangeByGroup(accommodationGroup);

    accommodationGroup.accommodations.forEach((accommodation) => {
      let isCheapestPriceRange = false;

      accommodation.priceRanges.forEach((priceRange) => {
        isCheapestPriceRange = priceRange.id === cheapestPriceRange.id;

        if (isCheapestPriceRange)
          setSelectedProperty(accommodation, isCheapestPriceRange);
      });
    });
  });
};

const setCheapestAccommodationGroup = (accommodationGroups) => {
  const cheapestPriceRange = findCheapestBetweenGroups(accommodationGroups);

  accommodationGroups.forEach((accommodationGroup) => {
    accommodationGroup.accommodations.forEach((accommodation) => {
      const isCheapestAccommodationGroup = accommodation.priceRanges.find(
        (priceRange) => priceRange.id === cheapestPriceRange.id
      );

      if (
        accommodationGroup.selected === undefined ||
        isCheapestAccommodationGroup
      )
        setSelectedProperty(accommodationGroup, isCheapestAccommodationGroup);
    });
  });
};

const setCheapestPriceRange = (accommodationGroup) => {
  accommodationGroup.accommodations.forEach((accommodation) => {
    const cheapestPriceRangeByAccomodation = findCheapestPriceRange(
      accommodation.priceRanges
    );

    accommodation.priceRanges.forEach((priceRange) => {
      const isCheapestPriceRange =
        priceRange.id === cheapestPriceRangeByAccomodation.id;

      setSelectedProperty(priceRange, isCheapestPriceRange);
    });
  });
};

const findCheapestPriceRangeByGroup = (accommodationGroup) => {
  const priceRanges = [];

  accommodationGroup.accommodations.forEach((accommodation) => {
    priceRanges.push(...accommodation.priceRanges);
  });

  const cheapestPriceRange = findCheapestPriceRange(priceRanges);

  return cheapestPriceRange;
};

const findCheapestPriceRange = (priceRanges) => {
  let cheapest = Number.MAX_SAFE_INTEGER;
  let cheapestPriceRange = null;

  priceRanges.forEach((priceRange) => {
    const price = priceRange.totalExchanged;

    if (price < cheapest) {
      cheapest = price;
      cheapestPriceRange = priceRange;
    }
  });

  return cheapestPriceRange;
};

const findCheapestBetweenGroups = (accommodationGroups) => {
  const priceRanges = [];

  accommodationGroups.forEach((accommodationGroup) => {
    const cheapestPriceRange =
      findCheapestPriceRangeByGroup(accommodationGroup);
    priceRanges.push(cheapestPriceRange);
  });

  const cheapestPriceRange = findCheapestPriceRange(priceRanges);

  return cheapestPriceRange;
};

const setSelectedProperty = (property, condition) => {
  // eslint-disable-next-line no-param-reassign
  property.selected = !!condition;
};

export const unsetAccommodationGroups = (accommodationGroups) => {
  accommodationGroups.forEach((accommodationGroup) => {
    // eslint-disable-next-line no-param-reassign
    accommodationGroup.selected = false;
  });

  return accommodationGroups;
};

export const unsetAccommodations = (accommodations) => {
  accommodations.forEach((accommodation) => {
    // eslint-disable-next-line no-param-reassign
    accommodation.selected = false;
  });
};

export const unsetPriceRanges = (priceRanges) => {
  priceRanges.forEach((priceRange) => {
    // eslint-disable-next-line no-param-reassign
    priceRange.selected = false;
  });
};

export const getSelectedAccommodationGroups = (accommodationGroups) =>
  accommodationGroups.filter((ac) => ac.selected === true);

export const getSelectedAccommodations = (group) =>
  group.accommodations.filter((a) => a.selected === true);

export const getSelectedPriceRanges = (accommodation) =>
  accommodation.priceRanges.filter((pr) => pr.selected === true);

export const getSelectedAccommodationId = (accommodationGroups) => {
  let id = 0;

  accommodationGroups.forEach((ag) => {
    if (ag.selected)
      ag.accommodations.forEach((a) => {
        if (a.selected)
          a.priceRanges.forEach((pr) => {
            if (pr.selected) id = a.id;
          });
      });
  });

  return id;
};

export const getSelectedAccommodationBedroomType = (accommodationGroups) => {
  let bedroomType = 0;

  accommodationGroups.forEach((ag) => {
    if (ag.selected)
      ag.accommodations.forEach((a) => {
        if (a.selected)
          a.priceRanges.forEach((pr) => {
            if (pr.selected) bedroomType = pr.bedroom;
          });
      });
  });

  return bedroomType;
};

export const toggleBedroomType = (group, bedroomType) => {
  group.accommodations.forEach((accommodation) => {
    const count = accommodation.priceRanges.filter(
      (pr) => pr.bedroom === bedroomType
    ).length;

    if (count > 0)
      accommodation.priceRanges.forEach((pr) => {
        pr.selected = parseInt(pr.bedroom, 10) === parseInt(bedroomType, 10);
      });
  });

  return group;
};

export const toggleAccommodationsBedroomType = (
  accommodationGroups,
  bedroomType
) => {
  const groups = accommodationGroups.map((group) => {
    toggleBedroomType(group, parseInt(bedroomType, 10));
  });

  return groups;
};

export const accommodationTotalPrices = (group) => {
  let discount = 0;
  let exchangeRate = 0;
  let price = 0;
  let priceExchanged = 0;
  let priceWithDiscount = 0;
  let priceWithDiscountExchanged = 0;
  let registrationFee = 0;
  let registrationFeeExchanded = 0;
  let registrationFeeWithDiscount = 0;
  let registrationFeeWithDiscountExchanged = 0;
  let supplementPrice = 0;

  if (group && group.accommodations.length > 0) {
    getSelectedAccommodations(group).forEach((selectedAccommodation) => {
      getSelectedPriceRanges(selectedAccommodation).forEach(
        (selectedPriceRange) => {
          exchangeRate = selectedPriceRange.exchangeRateUsed;

          supplementPrice = selectedPriceRange.supplementExchanged;

          registrationFee =
            selectedAccommodation.registrationFee / exchangeRate;
          registrationFeeWithDiscount =
            selectedAccommodation.registrationFeeWithDiscount / exchangeRate;

          registrationFeeExchanded = selectedAccommodation.registrationFee;
          registrationFeeWithDiscountExchanged =
            selectedAccommodation.registrationFeeWithDiscount;

          price = selectedPriceRange.price + registrationFee;
          priceWithDiscount =
            selectedPriceRange.total + registrationFeeWithDiscount;
          priceExchanged =
            selectedPriceRange.exchanged + registrationFeeExchanded;
          priceWithDiscountExchanged =
            selectedPriceRange.totalExchanged +
            registrationFeeWithDiscountExchanged;
          discount = priceExchanged - priceWithDiscountExchanged;
        }
      );
    });
  }

  return {
    discount,
    exchangeRate,
    price,
    priceExchanged,
    priceWithDiscount,
    priceWithDiscountExchanged,
    registrationFee,
    registrationFeeExchanded,
    registrationFeeWithDiscount,
    registrationFeeWithDiscountExchanged,
    supplement: supplementPrice,
    total: price,
    totalDiscount: priceWithDiscount,
    totalDiscountExchanged: priceWithDiscountExchanged,
    totalExchanged: priceExchanged,
  };
};

export const accommodationTotalPricesToCheckout = (checkout) => {
  let discount = 0;
  let exchangeRate = 0;
  let priceExchanged = 0;
  let priceWithDiscount = 0;
  let priceWithDiscountExchanged = 0;
  let registrationFeeExchanded = 0;
  let registrationFeeWithDiscount = 0;
  let registrationFeeWithDiscountExchanged = 0;
  let accommodation = {};

  if (accommodation && checkout?.accommodations.length > 0) {
    accommodation = checkout?.accommodations[0];

    exchangeRate = accommodation?.value?.exchangeRateUsed;

    registrationFeeWithDiscount =
      accommodation.registrationFee.withDiscountExchanged / exchangeRate;

    registrationFeeExchanded = accommodation?.registrationFee?.exchanged;

    registrationFeeWithDiscountExchanged =
      accommodation?.registrationFee?.withDiscountExchanged;

    priceWithDiscount = accommodation.value.total + registrationFeeWithDiscount;
    priceExchanged = accommodation.value.exchanged + registrationFeeExchanded;
    priceWithDiscountExchanged =
      accommodation.value.totalExchanged + registrationFeeWithDiscountExchanged;
    discount = priceExchanged - priceWithDiscountExchanged;
  }

  return {
    discount,
    priceExchanged,
    priceWithDiscount,
    registrationFeeExchanded,
    registrationFeeWithDiscountExchanged,
    totalDiscountExchanged: priceWithDiscountExchanged,
    totalExchanged: priceExchanged,
  };
};
